/**
 * @flow
 */
import {Reducer} from 'redux';
import type {SignInRequest, SignInResponse} from '../../types/api-types'
import type {APIAction, APIState} from '../../types/types'
import API from '../../services/API'

export type SignInActionType = 'SIGN_IN_PENDING' | 'SIGN_IN_DONE' | 'SIGN_IN_ERROR';

export interface SignInAction extends APIAction<SignInRequest, SignInResponse> {
  type: SignInActionType;
}

export interface SignInState extends APIState<SignInRequest, SignInResponse> {

}

const signInReducer: Reducer<SignInState, SignInAction> = (state = initialSignInState, action) => API.processAction(state, action, 'SIGN_IN');

const initialSignInState: SignInState = {status: ''};

export default signInReducer;
